<template>
    <div class="sidebar-header">
      <button v-if="view =='Edit' || 'Rules' "
        :class="{'active': activeTab === 'Inspect'}" 
        @click="updateActiveTab('Inspect')">{{ $t('SidebarHeader.Inspect') }}</button>
      <button v-if="view =='Preview'"
        :class="{'active': activeTab === 'Media'}" 
        @click="updateActiveTab('Media')">{{ $t('SidebarHeader.Media') }}</button>
      <button 
        :class="{'active': activeTab === 'Global'}" 
        @click="updateActiveTab('Global')">{{ $t('SidebarHeader.Global') }}</button> 
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from 'vuex';
  export default {
    name: 'SidebarHeader',
    computed: {
      ...mapState(['activeTab', 'view'])
    },
    methods: {
      ...mapActions(['updateActiveTab']),
    }
  };
  </script>
  
  <style scoped>
  .sidebar-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 50px;
    width: 100%;
    border-bottom: 1px solid #ddd;
  }
  
  .sidebar-header button {
    flex: 1;
    height: 100%;
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    outline: none;
  }
  
  .sidebar-header button.active {
    border-bottom: 2px solid black;
  }
  
  .sidebar-header button:not(.active):hover {
    background: #f0f0f0;
  }
  </style>
  
  
  